import { Outlet } from 'react-router-dom'
import { AppSidebar } from '@/components/layout/app-sidebar'
import { ConnectionBanner } from '@/components/layout/connection-banner'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'

export function AppShell(): React.JSX.Element {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="min-w-0 bg-page">
        <ConnectionBanner />
        <Outlet />
      </SidebarInset>
    </SidebarProvider>
  )
}
